import React, { useEffect, useState } from "react";
import { useCustomContext } from "../../../state/CustomContext";
import { callAPIForQuery } from "../../../utilities/service";
import { useNavigate, useSearchParams } from "react-router-dom";
import { cloneDeep } from "lodash";

const HospitalCreate: React.FC = () => {
    const context = useCustomContext();
    const navigate = useNavigate();
    const { state } = context;
    const [searchParams] = useSearchParams();
    // Ensure created_by is correctly set
    const userId = state?.user_id || "";
    const [tenant, setTenant] = useState([])
    const [formData, setFormData] = useState({
        id: -1,
        hospital_code: "",
        hospital_name: "",
        contact_no: "",
        address: "",
        pincode: "",
        email_id: "",
        tenant_id: "",
        isactive: "1", // Default to "Yes"
        created_by: userId,
    });

    const [errors, setErrors] = useState({
        hospital_code: "",
        hospital_name: "",
        contact_no: "",
        address: "",
        pincode: "",
        email_id: "",
        tenant_id: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
        }));

        setErrors((prev) => ({
            ...prev,
            [e.target.name]: "",
        }));
    };

    const validateForm = () => {
        let valid = true;
        let newErrors = {
            hospital_code: "",
            hospital_name: "",
            contact_no: "",
            address: "",
            pincode: "",
            email_id: "",
            tenant_id: "",
        };

        if (!formData.hospital_code.toString().trim()) {
            newErrors.hospital_code = "Hospital code is required";
            valid = false;
        }

        if (!formData.hospital_name.toString().trim()) {
            newErrors.hospital_name = "Hospital name is required";
            valid = false;
        }

        if (!formData.contact_no.toString().trim()) {
            newErrors.contact_no = "Contact number is required";
            valid = false;
        }

        if (!formData.address.toString().trim()) {
            newErrors.address = "Address is required";
            valid = false;
        }

        if (!formData.pincode.toString().trim()) {
            newErrors.pincode = "Pincode is required";
            valid = false;
        }

        if (!formData.email_id.toString().trim()) {
            newErrors.email_id = "Email ID is required";
            valid = false;
        }

        if (!formData.tenant_id.toString().toString().trim()) {
            newErrors.tenant_id = "Tenant ID is required";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };
    useEffect(() => {
        loadTenants();
        const id = searchParams.get("id");
        if (id)
            getHopsital(Number(id));
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const getHopsital = async (id: number) => {
        const response = await callAPIForQuery({ input: JSON.stringify({ id: id }), type: "get_hospital" }, "post")
        const formDataCopy: any = cloneDeep(formData);
        if (response?.[0]?.[0]) {
            Object.keys(response[0][0]).forEach((key: string) => {
                formDataCopy[key] = response[0][0][key]
            });
            setFormData(formDataCopy)
        } else {
            alert('Invalid request. Please contact your administrator');
        }
    }

    const loadTenants = async () => {
        const response = await callAPIForQuery({ input: JSON.stringify({ id: '%' }), type: "get_tenant" }, "post");
        setTenant(response[0])
    }
    const handleSubmit = async () => {
        if (!validateForm()) return;

        try {
            const response = await callAPIForQuery({ input: JSON.stringify(formData), type: "insert_update_hospital" }, "post");

            if (response.error) {
                alert("Some Error occurred")
            } else {
                alert("Saved Hospital successfully")
                navigate('/hospital-view');
            }


        } catch (error) {
            console.error("Error saving hospital:", error);
            alert("Failed to save hospital.");
        }
    };

    return (
        <>
         <div className="module-title">Hospital Creation</div>
            <div className="row">
                {/* Hospital Code */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Hospital Code</label>
                    <input type="text" name="hospital_code" value={formData.hospital_code} onChange={handleChange} className="form-control" />
                    {errors.hospital_code && <p className="text-danger">{errors.hospital_code}</p>}
                </div>

                {/* Hospital Name */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Hospital Name</label>
                    <input type="text" name="hospital_name" value={formData.hospital_name} onChange={handleChange} className="form-control" />
                    {errors.hospital_name && <p className="text-danger">{errors.hospital_name}</p>}
                </div>

                {/* Contact Number */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Contact Number</label>
                    <input type="text" name="contact_no" value={formData.contact_no} onChange={handleChange} className="form-control" />
                    {errors.contact_no && <p className="text-danger">{errors.contact_no}</p>}
                </div>

                {/* Address */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Address</label>
                    <input type="text" name="address" value={formData.address} onChange={handleChange} className="form-control" />
                    {errors.address && <p className="text-danger">{errors.address}</p>}
                </div>

                {/* Pincode */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Pincode</label>
                    <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} className="form-control" />
                    {errors.pincode && <p className="text-danger">{errors.pincode}</p>}
                </div>

                {/* Email ID */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Email ID</label>
                    <input type="email" name="email_id" value={formData.email_id} onChange={handleChange} className="form-control" />
                    {errors.email_id && <p className="text-danger">{errors.email_id}</p>}
                </div>

                {/* Tenant ID */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Tenant</label>
                    <select name="tenant_id" value={formData.tenant_id} onChange={handleChange} className="form-control">
                        <option value="-1">--Select--</option>
                        {tenant.map((opt: any) => {
                            return (<option value={opt.id}>{opt.name}</option>)
                        })}

                    </select>
                </div>

                {/* Is Active Dropdown */}
                <div className="form-option col-lg-3 mb-3">
                    <label className="field-title">Is Active</label>
                    <select name="isactive" value={formData.isactive} onChange={handleChange} className="form-control">
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                </div>
            </div>
            <div className="action-set">
                <div>
                    <input onClick={handleSubmit} type="button" className="form-control" value={formData.id > 0 ? "Update" : "Save"} />
                </div>

            </div>
        </>
    );
};

export default HospitalCreate;
